import { useEffect } from 'react';

const useOptimizelyInjector = ({ inApp, inject = false }) => {
    useEffect(() => {
        if (!inApp || (inApp && inject)) {
            const script = document.createElement('script');
            script.src = 'https://cdn.optimizely.com/js/5682015752683520.js';
            script.async = true;
            script.type = 'text/javascript';

            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, [inApp, inject]);

    return null; 
};

export default useOptimizelyInjector;